import React, { Fragment, useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AccountLeftSidebar from "../../components/AccountLeftSidebar/accountLeftSidebar";
import { membershipPayment } from "../../actions/payment";
import { Button, Modal } from "react-bootstrap";
import { connect } from "react-redux";
import PropTypes from "prop-types";
//components
import BreadCrumb from "../../components/breadcrumb/breadcrumb";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const MembershipPackages = (props) => {
  const [value, setValue] = useState({
    amount: 0,
    cardNumber: "",
    cardholderName: "",
    cvc: "",
    exp: "",
    year: "",
    tableClass: "show",
    paymentClass: "hide",
    successClass: "hide",
    paymentMethod: "",
    checkmark: "",
  });
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const _packageSelect = async (amount) => {
    value({ amount: amount, tableClass: "hide", paymentClass: "show" });
  };
  const buyPackage = async () => {};
  const _payNow = async () => {
    if (
      value.cardNumber !== "" &&
      value.cardholderName !== "" &&
      // value.exp !== "" &&
      value.cvc !== ""
    ) {
      var user_data = JSON.parse(localStorage.getItem("user"));

      if (user_data) {
        const data = {
          cardNumber: value.cardNumber,
          expirationDate: value.exp + value.year, //value.exp,
          cardCode: value.cvc,
          amount: parseFloat(value.amount),
          items: value.cart,
          userData: user_data,
        };

        const res = await props.membershipPayment(data);

        if (res.status === 200) {
          value({
            tableClass: "hide",
            paymentClass: "hide",
            successClass: "active",
            checkmark: "checkmark",
          });
        } else {
          toast.error(`${res.data.error.error.errorText}`, {
            containerId: "B",
          });
        }
      }
    } else {
      toast.error(`Please Fill All the fields`, { containerId: "B" });
    }
  };

  const { tableClass, paymentClass, successClass, checkmark } = value;
  const { isAuth, user } = props._auth;
  return (
    <Fragment>
      <ToastContainer
        enableMultiContainer
        containerId={"B"}
        position={toast.POSITION.TOP_RIGHT}
      />
      <div className="member-programm-wrapper wrapper-90 max-1600">
        <BreadCrumb title={`My Account`} />
        <div className="container-fluid">
          <div className="row">
            <AccountLeftSidebar />
            <div
              id="pts-content"
              style={{ padding: "10px" }}
              className="col-md-9"
            >
              <h1 className="text-center">Membership</h1>
              {user && user.membershipType === "free" ? (
                <div className="pts-text-center">
                  <div className={`table-responsive ${tableClass}`}>
                    <div className="membership-pricing-table">
                      <table>
                        <tbody>
                          <tr>
                            <th className="plan-header plan-header-free">
                              <div className="pricing-plan-name">
                                Memberships
                              </div>
                              <div className="pricing-plan-period">
                                (points)0.05 = $ value of points collected
                              </div>
                            </th>
                            <th className="plan-header plan-header-free">
                              <div className="pricing-plan-name">
                                Sundial Free Membership
                              </div>
                              <div className="pricing-plan-price">
                                <sup>$</sup>00<span>.00</span>
                              </div>
                            </th>

                            <th className="plan-header plan-header-standard">
                              <div className="header-plan-inner">
                                {/*<span className="plan-head"> </span>*/}
                                <span className="recommended-plan-ribbon">
                                  RECOMMENDED
                                </span>
                                <div className="pricing-plan-name">
                                  Sundial VIP
                                </div>
                                <div className="pricing-plan-price">
                                  <sup>$</sup>49<span>.99</span>
                                </div>
                                <div className="pricing-plan-period">year</div>
                              </div>
                            </th>
                          </tr>
                          <tr>
                            <td>
                              <b>Free delivery on transactions over $49</b>
                            </td>
                            <td>
                              <i className="fas fa-check-circle"></i>
                            </td>
                            <td>
                              <i className="fas fa-check-circle"></i>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <b>Free No-Rush Shipping</b>
                              (earn rewards for future purchases)
                            </td>
                            <td>
                              <i className="fas fa-check-circle"></i>
                            </td>
                            <td>
                              <i className="fas fa-check-circle"></i>
                            </td>
                          </tr>
                          <tr>
                            <td>
                              <b>
                                Collect reward points on your purchases Points
                                Ratio
                              </b>{" "}
                              (n: n)
                            </td>
                            <td>1:1</td>
                            <td>1:2</td>
                          </tr>

                          <tr>
                            <td>
                              <b>Sundial Care Package</b>
                              We'll send you a surprise gift every quarter for
                              free
                            </td>
                            <td>
                              <i className="fas fa-times-circle"></i>
                            </td>
                            <td>
                              <i className="fas fa-check-circle"></i>
                            </td>
                          </tr>
                          <tr>
                            <td />
                            <td>
                              <b>$0</b>
                            </td>
                            <td>
                              <b>$49.99 / Year</b>
                            </td>
                          </tr>
                          <tr>
                            <td />
                            <td />

                            <td>
                              {isAuth && !props._auth.loading ? (
                                <Button
                                  onClick={() => value._packageSelect(49.99)}
                                  className="text-center"
                                >
                                  Purchase
                                </Button>
                              ) : (
                                <Button className="text-center">Sign Up</Button>
                              )}
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className={`row ${paymentClass}`}>
                    <div className="col-md-12 text-center">
                      <h5>Enter Your Credit/Debit Card</h5>{" "}
                    </div>
                    <div
                      id="card-payment"
                      className="payment "
                      style={{
                        display: value.paymentMethod === 1 ? "none" : "block",
                      }}
                    >
                      <div className="row">
                        <div id="content" className="col-sm-12 px-5">
                          <form
                            id="card_payment_form"
                            className="form-horizontal"
                          >
                            <fieldset id="account">
                              <div
                                id="regular-field-cardholder-name"
                                className="form-group regular-field required"
                              >
                                <label
                                  className="col-sm-2 control-label"
                                  htmlFor="input-cardholder-name"
                                >
                                  Cardholder Name
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="text"
                                    name="cardholder-name"
                                    maxLength={32}
                                    placeholder="Jhon Doe"
                                    id="input-cardholder-name"
                                    className="form-control"
                                    onChange={(e) => {
                                      value({
                                        cardholderName: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                id="regular-field-card-number"
                                className="form-group regular-field required"
                              >
                                <label
                                  className="col-sm-2 control-label"
                                  htmlFor="input-card-number"
                                >
                                  Card Number
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="number"
                                    name="card-number"
                                    maxLength={16}
                                    placeholder="3566 0020 2036 0505"
                                    id="input-card-number"
                                    className="form-control"
                                    onInput={(e) => {
                                      e.target.value = Math.max(
                                        0,
                                        parseInt(e.target.value)
                                      )
                                        .toString()
                                        .slice(0, 16);
                                    }}
                                    onChange={(e) => {
                                      value({
                                        cardNumber: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                id="regular-field-cvc"
                                className="form-group regular-field required"
                              >
                                <label
                                  className="col-sm-2 control-label"
                                  htmlFor="input-cvc"
                                >
                                  CVC
                                </label>
                                <div className="col-sm-10">
                                  <input
                                    type="number"
                                    name="cvc"
                                    maxLength="3"
                                    onInput={(e) => {
                                      e.target.value = Math.max(
                                        0,
                                        parseInt(e.target.value)
                                      )
                                        .toString()
                                        .slice(0, 3);
                                    }}
                                    placeholder={"013"}
                                    id="input-cvc"
                                    className="form-control"
                                    onChange={(e) => {
                                      value({
                                        cvc: e.target.value,
                                      });
                                    }}
                                  />
                                </div>
                              </div>
                              <div
                                id="regular-field-exp"
                                className="form-group regular-field required"
                              >
                                <label
                                  className="col-sm-2 control-label"
                                  htmlFor="input-exp"
                                >
                                  Exp.
                                </label>
                                <div className="col-sm-10">
                                  <select
                                    name="months"
                                    className="mr-2"
                                    id="months"
                                    onChange={(e) => {
                                      value({
                                        exp: e.target.value,
                                      });
                                    }}
                                  >
                                    <option value={"01"}>January</option>
                                    <option value={"02"}>February </option>
                                    <option value={"03"}>March</option>
                                    <option value={"04"}>April</option>
                                    <option value={"05"}>May</option>
                                    <option value={"06"}>June</option>
                                    <option value={"07"}>July</option>
                                    <option value={"08"}>August</option>
                                    <option value={"09"}>September</option>
                                    <option value={"10"}>October</option>
                                    <option value={"11"}>November</option>
                                    <option value={"12"}>December</option>
                                  </select>
                                  <select
                                    name="months"
                                    id="months"
                                    onChange={(e) => {
                                      value({
                                        year: e.target.value,
                                      });
                                    }}
                                  >
                                    <option value={"18"}>2018</option>
                                    <option value={"19"}>2019</option>
                                    <option value={"20"}>2020</option>
                                    <option value={"21"}>2021</option>
                                    <option value={"22"}>2022</option>
                                    <option value={"23"}>2023</option>
                                    <option value={"24"}>2024</option>
                                    <option value={"25"}>2025</option>
                                    <option value={"26"}>2026</option>
                                    <option value={"27"}>2027</option>
                                    <option value={"28"}>2028</option>
                                  </select>
                                </div>
                              </div>
                            </fieldset>
                          </form>
                          <button
                            className="btn btn-primary btn-info-full"
                            onClick={_payNow}
                          >
                            Pay Now
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className={`row ${successClass}`}>
                    <svg
                      className={`${checkmark}`}
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 52 52"
                    >
                      <circle
                        className="checkmark__circle"
                        cx="26"
                        cy="26"
                        r="25"
                        fill="none"
                      />
                      <path
                        className="checkmark__check"
                        fill="none"
                        d="M14.1 27.2l7.1 7.2 16.7-16.8"
                      />
                    </svg>
                    <div className="col-md-12 text-center">
                      <h5>Thank You for Perchase Package</h5>
                    </div>
                  </div>
                </div>
              ) : (
                <div className={`row`}>
                  <svg
                    className={`checkmark`}
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 52 52"
                  >
                    <circle
                      className="checkmark__circle"
                      cx="26"
                      cy="26"
                      r="25"
                      fill="none"
                    />
                    <path
                      className="checkmark__check"
                      fill="none"
                      d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    />
                  </svg>
                  <div className="col-md-12 text-center">
                    <h5>You Have already purchased a Package</h5>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};
membershipPayment.prototype = {
  membershipPayment: PropTypes.func.isRequired,
};
const mapStateToProps = (state) => ({
  _auth: state.auth,
});
export default connect(mapStateToProps, { membershipPayment })(
  MembershipPackages
);
